import { Link, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "../lib/AuthContext";
import { Bookmark, LogIn, LogOut, User, Compass, BookOpen } from "lucide-react";
import { logout as logoutApi } from "../lib/api";

export const TopNav = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await logoutApi(); } catch (_) {}
    setUser(null);
    navigate("/");
  };

  return (
    <header className="fixed top-0 inset-x-0 z-40">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 pt-4">
        <div className="glass-strong rounded-full px-4 sm:px-6 py-2.5 flex items-center justify-between">
          <Logo />
          <nav className="flex items-center gap-1.5 sm:gap-3">
            <Link
              to="/discover"
              data-testid="nav-discover"
              className="hidden sm:inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 hover:text-white px-3 py-2 rounded-full hover:bg-white/5 transition"
            >
              <Compass className="h-3.5 w-3.5" /> Discover
            </Link>
            <Link
              to="/guide"
              data-testid="nav-guide"
              className="hidden sm:inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 hover:text-white px-3 py-2 rounded-full hover:bg-white/5 transition"
            >
              <BookOpen className="h-3.5 w-3.5" /> Guide
            </Link>
            <Link
              to="/dashboard"
              data-testid="nav-saved"
              className="hidden sm:inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 hover:text-white px-3 py-2 rounded-full hover:bg-white/5 transition"
            >
              <Bookmark className="h-3.5 w-3.5" /> Saved
            </Link>
            {user ? (
              <>
                <div className="flex items-center gap-2 pl-2 sm:pl-3 pr-1 py-1 rounded-full bg-white/5 border border-white/10">
                  {user.picture ? (
                    <img src={user.picture} alt={user.name} className="h-7 w-7 rounded-full object-cover" />
                  ) : (
                    <span className="h-7 w-7 rounded-full bg-zinc-800 inline-flex items-center justify-center"><User className="h-3.5 w-3.5"/></span>
                  )}
                  <button
                    data-testid="logout-btn"
                    onClick={handleLogout}
                    className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 hover:text-white pr-2 py-1 transition"
                    title="Sign out"
                  >
                    <LogOut className="h-3.5 w-3.5" />
                  </button>
                </div>
              </>
            ) : (
              <Link
                to="/login"
                data-testid="nav-login"
                className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-black bg-white hover:bg-zinc-200 px-3.5 sm:px-4 py-2 rounded-full transition"
              >
                <LogIn className="h-3.5 w-3.5" /> Sign in
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};
